export { supportedLanguages } from "@/lib/i18n/config";
export { i18nRuntime as default } from "@/lib/i18n/runtime";
